import { primaryColor, errorColor, borderColor } from "../colors";

export const borderRadius = "4px";

export const borderStyle = "1px solid #E2E8F0";

export const scrollBarStyle = {
  overflowY: "auto",

  // WebKit-based browsers (Chrome, Safari, Edge)
  "&::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: primaryColor,
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "blue.700",
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-button": {
    display: "none",
  },

  // Browsers that do not support WebKit (Firefox)
  "@supports not (selector(::-webkit-scrollbar))": {
    scrollbarWidth: "thin",
    scrollbarColor: `${primaryColor} transparent`,
  },
};

export const formFooterStyle = {
  bottom: "0",
  left: "0",
  right: "0",
  height: "108px",
  padding: "32px 64px 0px 64px",
  marginLeft: "238px",
  borderTop: "1px solid #CBD5E0",
  boxShadow: "0px -6px 22px 0px rgba(0, 0, 0, 0.11)",
  backgroundColor: "#F7FAFC",
  zIndex: "0",
};

export const menuItemStyles = {
  display: "block",
  borderLeftColor: primaryColor,
  padding: "6px 12px",
};

export const menuListStyles = {
  borderRadius: "12px",
  padding: "10px",
};

export const menuItemActiveStyles = {
  display: "block",
  borderRadius: borderRadius,
  borderColor: "#000",
  backgroundColor: "#1F4470",
  padding: "6px 12px",
};

export const styleFilterSection = {
  backgroundColor: "white",
  padding: "30px",
  borderRadius: "10px",
};

export const mainSectionOfSearchAndFilter = {
  border: "1.5px solid grey",
  borderRadius: "8px",
  backgroundColor: "white",
};

export const formStyles = {
  bgColor: "#fff",
  borderWidth: "2px",
  borderColor: borderColor,
  borderRadius: borderRadius,
};

export const selectStyles = {
  control: (styles) => ({
    ...styles,
    borderRadius: borderRadius,
    "&:hover": {
      borderColor: "none",
    },
  }),
};

export const conditionalFieldStyles = {
  borderLeft: "1px solid",
  paddingLeft: "5",
  borderColor: primaryColor,
};

export const errorStyle = {
  border: "1px solid",
  borderColor: errorColor,
  boxShadow: "0 0 0 1px #E53E3E",
  borderRadius: borderRadius,
};

export const textAreaStyle = {
  backgroundColor: "white",
  _disabled: {
    opacity: "1",
    color: "gray.400",
    bg: "gray.100",
    borderColor: "gray.200",
    fontWeight: "400",
  },
};
